module.exports = {"id":"s1-q3","text":"Does your job require you to use any electronic equipment or machinery?","multiselect":false,"options":[{"text":"Yes","id":"s1-q3-a1","next":"s1-q3a","capability":1,"access":1,"focusarea":[0,0,0,0,4]},{"text":"No","id":"s1-q3-a2","next":"s1-q4","capability":-2,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s1-q3.json
// module id = 890
// module chunks = 41